/** @jsx jsx */
/* eslint-disable no-use-before-define,no-mixed-operators */
import { jsx } from '@emotion/core'
import React from 'react'
import { hideModal, parseHtml, fmt } from '../twd'
import { tableCss } from './style'
export default ({issue={}, offer={}} = {}) => {

    return <React.Fragment>
    <div className="modal-dialog modal-sm">
    <div className="modal-content">
        <div className="modal-header">
            <button
                data-name="bond-detail-ars-info-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h3 className="modal-title text-center">ARS Info</h3>
            <h5 className="modal-title text-center vertical-offset-sm"
                dangerouslySetInnerHTML={{__html:parseHtml(issue.formulaText).replaceAll('<BR>', ' ')}} />

            <div className="row form-group subhead">
            <div className="col-xs-12 col-md-12">

            <div className="table-responsive">
            <table
                data-name='bond-detail-ars-info-table'
                className="table align-top"
                css={tableCss}>
            <tbody>
                <tr>
                    <td>Reset frequency</td>
                    <td>{issue.resetFreqDesc}</td>
                </tr>
                <tr>
                    <td>Current reset</td>
                    <td>{ fmt.mdy(
                        issue.cachedDatum.f2fFixedInd==='Y'
                        ? null
                        : (offer.prevCoupon || issue.prevCoupon)
                    ) }</td>
                </tr>
                <tr>
                    <td>Next reset</td>
                    <td>{ fmt.mdy(
                        issue.cachedDatum.f2fFixedInd==='Y'
                        ? (offer.nextResetDate || issue.nextResetDate)
                        : (offer.nextCoupon || issue.nextCoupon)
                    ) }</td>
                </tr>
                <tr>
                    <td>Current determination</td>
                    <td>{ fmt.mdy(
                        issue.cachedDatum.f2fFixedInd==='Y'
                        ? null
                        : (offer.determinationDt || issue.determinationDt)
                    ) }</td>
                </tr>
                <tr>
                    <td>Next determination</td>
                    <td>{ fmt.mdy(
                        offer.nextDeterminationDt || issue.nextDeterminationDt
                    ) }</td>
                </tr>
                <tr>
                    <td>Floor</td>
                    <td>{issue.floatFloor || fmt.empty()}</td>
                </tr>
                <tr>
                    <td>Cap</td>
                    <td>{issue.floatCeiling || fmt.empty()}</td>
                </tr>
                <tr>
                    <td>Formula</td>
                    <td dangerouslySetInnerHTML={{__html:parseHtml(issue.formulaText).replaceAll('<BR>', ' ')}}></td>
                </tr>

            </tbody>
            </table>
            </div>

            </div>
            </div>
        </div>

    </div>
    </div>
    </React.Fragment>
}





// WEBPACK FOOTER //
// ./src/bond-detail/ars-info-modal.js